import React from 'react';

/**
 * <PageHeader
 *    eyebrow="THREAT INTELLIGENCE"
 *    title="Domain Analysis"
 *    subtitle="Multi-source reputation scoring"
 *    actions={<Button .../>}
 * />
 */
export default function PageHeader({
  eyebrow,
  title,
  subtitle,
  actions,
  style,
  ...rest
}) {
  return (
    <div
      style={{
        display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
        paddingBottom: 'var(--sp-5)',
        borderBottom: '1px solid var(--border-subtle)',
        gap: 'var(--sp-4)', flexWrap: 'wrap',
        ...style,
      }}
      {...rest}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
        {eyebrow && (
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            fontSize: 'var(--fs-2xs)', fontWeight: 'var(--fw-bold)',
            color: 'var(--text-muted)',
            letterSpacing: '0.15em', fontFamily: 'var(--font-mono)',
          }}>
            <span aria-hidden style={{
              width: 5, height: 5, borderRadius: '50%',
              background: 'var(--cyan)', boxShadow: '0 0 6px var(--cyan)',
            }}/>
            {eyebrow}
          </div>
        )}
        <h1 style={{
          fontSize: 'var(--fs-2xl)', fontWeight: 'var(--fw-bold)',
          color: 'var(--text-primary)',
          letterSpacing: 'var(--ls-tight)', lineHeight: 'var(--lh-tight)',
          margin: 0,
        }}>
          {title}
        </h1>
        {subtitle && (
          <div style={{
            fontSize: 'var(--fs-xs)', color: 'var(--text-muted)',
            fontFamily: 'var(--font-mono)',
          }}>
            {subtitle}
          </div>
        )}
      </div>
      {actions && (
        <div style={{ display: 'flex', gap: 'var(--sp-2)', alignItems: 'center' }}>
          {actions}
        </div>
      )}
    </div>
  );
}
